//Library Imports
import FadeIn from "react-fade-in";

// application components goes here
import bulb from "../../../../assets/img/icons/bulb.svg";
import { WELCOME_DELAY, WELCOME_TRANSITION_DURATION } from "../../../../constants/index";

// styles goes here
import styled from "styled-components";
import { keyframes } from "styled-components";

const fadeOut = keyframes`
0%{opacity: 1}
100%{opacity: 0}`;

const AnimationWrapper = styled.div`
  display: flex;
  .welcome-text {
    animation-name: ${fadeOut};
    animation-delay: 2s;
    animation-duration: 2s;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
    animation-timing-function: ease-all;
  }
`;

const OnBoarding2: React.FC = (props) => {
  return (
    <div className="onBoarding">
      <FadeIn delay={WELCOME_DELAY} transitionDuration={WELCOME_TRANSITION_DURATION}>
        <AnimationWrapper>
          <div className="welcome-text second-intro">
            <div className="d-flex max-width-75">
              <img src={bulb} alt="step 1" className="margin-xl roy-dp" />
              <div className="heading">
                <h4>
                  We help you start, join and stay top of mind in{" "}
                  <span className="green-text"> today’s conversations, today </span> with your audience{" "}
                </h4>
              </div>
            </div>
          </div>
        </AnimationWrapper>
      </FadeIn>
    </div>
  );
};

export default OnBoarding2;
